export const getFileBase64 = (fileContent, saveFileBase64) => {
  const fileReader = new FileReader();

  fileReader.onload = (fileLoadedEvent) => {
    const base64 = fileLoadedEvent.target.result;

    saveFileBase64(base64.slice(37));
  };

  fileReader.readAsDataURL(fileContent);
};
